<template>
    <div id="swjcView">
        <!--24小时接单 立即咨询-->
        <div>
            <dialogueView />
        </div>
        <!--顶部我的日常咨询 我的检测报告-->
        <div class="cjkTop">
            <guidanceTestView />
        </div>

        <!--我的稽查诊断-->
        <div class="myJCZD">
            <div class="jczdTopNav">
                <img class="jczdIcon" :src="imgObj.icon_jczd" alt="">
                <span>我的稽查诊断</span>
            </div>
            <div class="jczdContent">
                <div class="jczdListBox">
                    <div 
                        class="jczdNavList"
                        v-for="(item,index) in jczdTypeList" 
                        :key="index"
                        @click="jczdNavListCLick(index)"
                        :class="jczdTypeIndex==index?'jczdNavListCheck':''">
                        {{ item.name }}
                    </div>
                </div>
                <div class="jczdListBorder"></div>
                <div v-if="isShowSSE==true">
                    <jczdSSEView ref="jczdSSEView" :sendSEEObj="sendSEEObj" />
                </div>
                <div class="jczdBottom" v-show="isShowSSE==false">
                    <div class="jdzdBox" v-if="jczdTypeIndex==0">
                        <div class="startCheckView">
                            <div class="startCheckLeft">
                                <p v-if="jdzdCheckObj.id==''">
                                    请选择下方你关注的
                                    <span class="colorSpanBlue">“焦点”</span>
                                    ，选中后点击
                                    <span class="colorSpanBlue">“开始稽查诊断”</span>
                                    ，获得专属诊断方案。
                                </p>
                                <p v-else>
                                    您当前选择的分类：
                                    <span class="colorSpanBlue">{{ jdzdCheckObj.name }}</span>
                                </p>
                            </div>
                            <div class="startBtn" @click="jczdStartBtn('焦点诊断','zd')">开始稽查诊断</div>
                        </div>
                        <div class="jczdTreeListBox">
                            <div class="jczdTreeLevelOne" 
                                v-for="(item,index) in jdzdTreeData" 
                                :key="index">
                                <div class="jczdTreeListLevelOneName">
                                    {{ item.name }}
                                    <div class="listLevelOneRightIsOpen" @click.stop="sqzkClick(item,index)">
                                        <img v-if="item.isOpen == true" :src="imgObj.icon_sq" alt="">
                                        <img v-else :src="imgObj.icon_zk" alt="">
                                        <span v-if="item.isOpen == true">收起</span>
                                        <span v-else>查看</span>
                                    </div> 
                                </div>
                                <div class="jczdTreeLevelTwo" v-if="item.isOpen == true">
                                    <div 
                                        class="jczdTreeChildList"
                                        v-for="(item_c,index_c) in item.childs" 
                                        :key="index_c"
                                        @click.stop="jdzdListCLick(item_c)">
                                        {{ item_c.name }}
                                        <div v-if="jdzdCheckObj.name==item_c.name" class="treeListCheck">
                                            <img :src="imgObj.icon_check" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hyzdBox" v-if="jczdTypeIndex==1">
                        <div class="startCheckView">
                            <div class="startCheckLeft">
                                <p class="startCheckLeftTop" v-if="hyzdCheckObj.id1==''&&hyzdCheckObj.id2==''">
                                    请选择下方你关注的
                                    <span class="colorSpanBlue">“行业”</span>
                                    ，选中后点击
                                    <span class="colorSpanBlue">“开始稽查诊断”</span>
                                    ，获得专属诊断方案。
                                </p>
                                <div v-else>
                                    <p class="startCheckLeftTop">
                                        您当前选择的分类：
                                    </p>
                                    <div class="hyzdCheck" v-if="hyzdCheckObj.id1!=''">
                                        <div class="hyzdCheckLeft">一级分类：</div>
                                        <div class="hyzdCheckRight" v-if="hyzdCheckObj.id1!==''">
                                            <span>{{ hyzdCheckObj.name1 }}</span>
                                            <div class="closeX"  @click="hyzdClearCheck(1)">
                                                <span>✕</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hyzdCheck" v-if="hyzdCheckObj.id2!=''">
                                        <div class="hyzdCheckLeft">二级分类：</div>
                                        <div class="hyzdCheckRight">
                                            <span>{{ hyzdCheckObj.name2 }}</span>
                                            <div class="closeX" @click="hyzdClearCheck(2)">
                                                <span>✕</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="startBtn" @click="jczdStartBtn('行业诊断','hyzd')">开始稽查诊断</div>
                        </div>
                        <div class="hyzdTreeListBox" v-loading="dataLoading">
                            <div class="hyzdTreeLevel">
                                <div class="hyzdTreeLevelTop">一级分类</div>
                                <div class="hyzdTreeChild">
                                    <div 
                                        class="hyzdTreeChildList" 
                                        v-for="(item,index) in hyzdTreeData" 
                                        :key="index"
                                        @click="hyzdLevel1CLick(item)">
                                        {{ item.name }}
                                        <div v-if="hyzdCheckObj.name1==item.name" class="treeListCheck">
                                            <img :src="imgObj.icon_check" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="hyzdTreeLevel">
                                <div class="hyzdTreeLevelTop">二级分类</div>
                                <div class="hyzdTreeChild">
                                    <div 
                                        class="hyzdTreeChildList" 
                                        v-for="(item,index) in hyzdTreeDataLevel2" 
                                        :key="index"
                                        @click="hyzdLevel2CLick(item)">
                                        {{ item.name }}
                                        <div v-if="hyzdCheckObj.name2==item.name" class="treeListCheck">
                                            <img :src="imgObj.icon_check" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--问题诊断-->
                    <div class="wtzdBox" v-show="jczdTypeIndex==2">
                        <div class="jiqirenView">
                            <div class="jqrTop" v-if="isShowWTZDSSE==false">
                                <div class="jqrLeft">
                                    <img :src="imgObj.robot_avatar" alt="">
                                </div>
                                <div class="jqrText">
                                    {{  jqrTextWill }}
                                </div>
                            </div>
                            <div v-if="isShowWTZDSSE==true">
                                <jczdSSEView ref="jczdSSEView" :sendSEEObj="sendSEEObjWTZD" />
                            </div>
                        </div>
                        <div class="userTextView">
                            <div class="userTextTop">
                                <el-input
                                    type="textarea"
                                    :rows="4"
                                    :maxlength=1000
                                    placeholder="请输入您想咨询的问题，每次提问都将开启一次新的对话噢~"
                                    v-model="wentiUserText">
                                </el-input>
                            </div>
                            <div class="userTextBottom">
                                <div class="userTextNum">
                                    <p>{{ wentiUserText.length }}/1000</p>
                                </div>
                                <div class="userTextBtn">
                                    <div class="userTextBtnClear" @click="userTextClear"><text class="iconfont">&#xe8af;</text>重置</div>
                                    <div class="userTextBtnSubmit" @click="userTextSubmit">诊断</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--政策诊断-->
                    <div class="zczdBox" v-if="jczdTypeIndex==3">
                        <!--政策诊断 顶部的几个分类-->
                        <div class="zczdTopNav">
                            <div 
                                :id="item.name=='行业'?'specialView':''"
                                class="zczdTopNavList" 
                                v-for="(item,index) in zczdTopType" 
                                :key="index"
                                :class="zczdTopTypeIndex == index?'zczdTopNavListCheck':''"
                                @click="zczdTopTypeClick(item,index)">
                                {{ item.name }}
                            </div>
                        </div>
                        <!--政策诊断 未选中|选中的 + 开始稽查-->
                        <div class="startCheckView">
                            <div class="startCheckLeft">
                                <!--没有选择时-->
                                <div v-if="zczdCheckObj.id1==''&&zczdCheckObj.id2==''&&zczdCheckObj.id3==''">
                                    <p class="weixuanzhong" v-if="zczdTopTypeIndex == 1">
                                        <span>请根据下方选项，确认您所需稽查诊断的</span>
                                        <span class="colorSpanBlue">税种</span>
                                        <span>及</span>
                                        <span class="colorSpanBlue">税制要素</span>
                                        <span>和</span>
                                        <span class="colorSpanBlue">征管环节</span>
                                        <span>。选中后点击</span>
                                        <span class="colorSpanBlue">“开始稽查诊断”</span>
                                        <span>获得专属税种稽查诊断方案，</span>
                                    </p>
                                    <p class="weixuanzhong" v-if="zczdTopTypeIndex == 2">
                                        <span>请根据下方选项，确认您所需的</span>
                                        <span class="colorSpanBlue">规费基金</span>
                                        <span>。选中后点击</span>
                                        <span class="colorSpanBlue">“开始稽查诊断”</span>
                                        <span>获得专属规费基金稽查诊断方案，</span>
                                    </p>
                                    <p class="weixuanzhong" v-if="zczdTopTypeIndex == 3">
                                        <span>请根据下方选项，确认您所需的</span>
                                        <span class="colorSpanBlue">企业经营环节</span>
                                        <span>。选中后点击</span>
                                        <span class="colorSpanBlue">“开始稽查诊断”</span>
                                        <span>获得专属企业经营环节稽查诊断方案，</span>
                                    </p>
                                    <p class="weixuanzhong" v-if="zczdTopTypeIndex == 4">
                                        <span>请根据下方选项，确认您所需的</span>
                                        <span class="colorSpanBlue">税收优惠</span>
                                        <span>。选中后点击</span>
                                        <span class="colorSpanBlue">“开始稽查诊断”</span>
                                        <span>获得专属税收优惠稽查诊断方案，</span>
                                    </p>
                                </div>
                                <!--有选择时-->
                                <div v-else class="moreCheckView">
                                    <p class="startCheckLeftTop">您当前选择的分类：</p>

                                    <div class="zczdCheck" v-if="zczdCheckObj.id1!=''">
                                        <div class="zczdCheckLeft">
                                            <span v-if="zczdTopTypeIndex == 1">税种分类：</span>
                                            <span v-else>一级分类</span>
                                        </div>
                                        <div class="zczdCheckRight" v-if="zczdCheckObj.id1!==''">
                                            <span>{{ zczdCheckObj.name1 }}</span>
                                            <div class="closeX"  @click="zczdClearCheck(1)">
                                                <span>✕</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="zczdCheck" v-if="zczdCheckObj.id2!=''">
                                        <div class="zczdCheckLeft">
                                            <span v-if="zczdTopTypeIndex == 1">税制要素：</span>
                                            <span v-else>二级分类</span>
                                        </div>
                                        <div class="zczdCheckRight" v-if="zczdCheckObj.id2!==''">
                                            <span>{{ zczdCheckObj.name2 }}</span>
                                            <div class="closeX"  @click="zczdClearCheck(2)">
                                                <span>✕</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="zczdCheck" v-if="zczdCheckObj.id3!=''">
                                        <div class="zczdCheckLeft">
                                            <span v-if="zczdTopTypeIndex == 1">征管环节：</span>
                                            <span v-else>三级分类</span>
                                        </div>
                                        <div class="zczdCheckRight" v-if="zczdCheckObj.id3!==''">
                                            <span>{{ zczdCheckObj.name3 }}</span>
                                            <div class="closeX"  @click="zczdClearCheck(3)">
                                                <span>✕</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="startBtn" @click="jczdStartBtn('政策诊断','zczd')">开始稽查诊断</div>
                        </div>
                        <div class="zczdTreeListBox" v-loading="dataLoading">
                            <div class="zczdTreeLevel">
                                <div class="zczdTreeLevelTop">
                                    <span v-if="zczdTopTypeIndex == 1">税种分类</span>
                                    <span v-else>一级分类</span>
                                </div>
                                <div class="zczdTreeChild">
                                    <div 
                                        class="zczdTreeChildList" 
                                        v-for="(item,index) in zczdTreeData" 
                                        :key="index"
                                        @click="zczdLevel1CLick(item,1)">
                                        {{ item.name }}
                                        <div v-if="zczdCheckObj.name1==item.name" class="treeListCheck">
                                            <img :src="imgObj.icon_check" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="zczdTreeLevel">
                                <div class="zczdTreeLevelTop">
                                    <span v-if="zczdTopTypeIndex == 1">税制要素</span>
                                    <span v-else>二级分类</span>
                                </div>
                                <div class="zczdTreeChild">
                                    <div 
                                        class="zczdTreeChildList" 
                                        v-for="(item,index) in zczdTreeDataLevel2" 
                                        :key="index"
                                        @click="zczdLevel1CLick(item,2)">
                                        {{ item.name }}
                                        <div v-if="zczdCheckObj.name2==item.name" class="treeListCheck">
                                            <img :src="imgObj.icon_check" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="zczdTreeLevel">
                                <div class="zczdTreeLevelTop">
                                    <span v-if="zczdTopTypeIndex == 1">征管环节</span>
                                    <span v-else>三级分类</span>
                                </div>
                                <div class="zczdTreeChild">
                                    <div 
                                        class="zczdTreeChildList" 
                                        v-for="(item,index) in zczdTreeDataLevel3" 
                                        :key="index"
                                        @click="zczdLevel1CLick(item,3)">
                                        {{ item.name }}
                                        <div v-if="zczdCheckObj.name3==item.name" class="treeListCheck">
                                            <img :src="imgObj.icon_check" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--场景规则定制库-->
        <div class="ruleView">
            <div v-for="(item,index) in ruleListArr" :key="index" class="ruleList">
                <div class="ruleListTitle">
                    {{ item.name }}
                </div>
                <div class="ruleListChild">
                    <div 
                        v-for="(item_c,index_c) in item.data" 
                        :key="index_c" 
                        class="ruleChildList"
                        @click="ruleChildClick(item,item_c,index)">
                        {{ item_c.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


import icon_wdjcbg from '@/assets/wdjjfa.png'
import icon_jczd from '@/assets/images/swjcw/icon_jczd.png'
import icon_check from '@/assets/images/swjcw/icon_check.png'
import icon_zk from '@/assets/images/swjcw/icon_zk.png'
import icon_sq from '@/assets/images/swjcw/icon_sq.png'
import robot_avatar from '@/assets/images/swjcw/robot-avatar.png'



//引入列表
import { ruleList } from '@/config/ruleList.js'

//引入模块
import guidanceTestView from './guidance_test/index.vue'
import dialogueView from './dialogue/index.vue'
import jczdSSEView from './jwzdSSE/index.vue'

//引入接口
import { tagTreeCache, jczdGetTagTree,zczdGetTagTree } from "@/api/api";


export default {
    name:'',
    components:{
        guidanceTestView,
        dialogueView,
        jczdSSEView
    },
    data(){
        return{
            //图片地址
            imgObj: {
                icon_wdjcbg,
                icon_jczd,
                icon_check,
                icon_zk,
                icon_sq,
                robot_avatar,
            },
            //列表展示
            ruleListArr:ruleList,
            //稽查诊断 选中的分类
            jczdTypeIndex:0,
            //稽查诊断的几个分类
            jczdTypeList:[
                {
                    name:'焦点诊断',
                    id:0,
                },
                {
                    name:'行业诊断',
                    id:1,
                },
                {
                    name:'问题诊断',
                    id:2,
                },
                {
                    name:'政策诊断',
                    id:3,
                }
            ],
            //是否展示稽查诊断下的sse
            isShowSSE:false,
            //是否正在sse
            isSSEing:false,
            sendSEEObj:{
                markDownH:'300px',
            },
            dataLoading:false,
            //收藏的code
            collectionCodeObj:{
                zd:'aiw-jdzd',
                hyzd:'aiw-hyzd',
                zczd:'aiw-zczd'
            },
            //焦点诊断 列表
            jdzdTreeData:[],
            //行业诊断 列表
            hyzdTreeData:[],
            //行业诊断 默认二级
            hyzdTreeDataLevel2:[],
            //焦点诊断 选中的标签
            jdzdCheckObj:{
                id:'',
                name:'',
            },
            //问题诊断 机器人的文字
            jqrText:'你好，我是你的稽查问题诊断小助手。你可以随时向我进行提问~ 特别说明：稽查问题诊断为一问一答，每次提问都将开启新对话哟！',
            jqrTextWill:'',
            wentiUserText:'',
            isShowWTZDSSE:false,
            sendSEEObjWTZD:{
                markDownH:'200px',
            },
            //行业诊断 选中的标签 
            hyzdCheckObj:{
                id1:'',
                id2:'',
                name1:'',
                name2:'',
            },
            //政策诊断 选中的标签
            zczdCheckObj:{
                id1:'',
                id2:'',
                id3:'',
                name1:'',
                name2:'',
                name3:'',
            },
            //政策 列表 默认二级 三级
            zczdTreeDataAll:[],
            zczdTreeData:[],
            zczdTreeDataLevel2:[],
            zczdTreeDataLevel3:[],
            //政策诊断的顶部分类选择
            zczdTopTypeIndex:1,
            //政策诊断的顶部分类
            zczdTopType:[
                {
                    name:'行业',
                    id:'',
                },
                {
                    name:'税种',
                    id:'',
                },
                {
                    name:'规费基金',
                    id:'',
                },
                {
                    name:'企业经营环节',
                    id:'',
                },
                {
                    name:'税收优惠',
                    id:'',
                }
            ]
        }
    },
    created(){
        //获取基础数据
        this.getDataRule()
        //焦点诊断
        this.getTreeJDZD()
    },
    methods:{
        
        //我的稽查诊断顶部选择
        jczdNavListCLick(index){
            //选择的是当前的么 
            if(this.jczdTypeIndex == index){
                return
            }
            //切换分类时判断是否在sse 
            if(this.isSSEing == true){
                //提示 先关闭sse再进行分类切换
                this.$message({
                    message:"您正在sse",
                    type:'warning',
                })
                return
                //子组件的方法
                console.log('关闭sse')
            }
            //选中的
            this.jczdTypeIndex = index;
            //关闭sse
            this.isShowSSE = false;

            //问题诊断的状态重置
            // this.isShowWTZDSSE = false;
            // this.wentiUserText = '';

            
            if(index == 1){
                //如果有数据就不用调用接口了
                if(this.hyzdTreeData.length==0){
                    this.getTreeHYZD()
                }
            }else if(index == 2){
                if(this.isShowWTZDSSE==false){
                    this.jqrTextWill = '';
                    this.textWillFn()
                }
            }else if(index == 3){
                //如果有数据就不用调用接口了
                if(this.zczdTreeDataAll.length==0){
                    this.getTreeZczd()
                }else{
                    //默认选中税种 及税种相关
                    this.zczdTopTypeIndex = 1;
                    this.zczdCheckObj.id1 = '';
                    this.zczdCheckObj.id2 = '';
                    this.zczdCheckObj.id3 = '';
                    this.zczdCheckObj.name1 = '';
                    this.zczdCheckObj.name2 = '';
                    this.zczdCheckObj.name3 = '';
                    this.zczdTreeData = this.zczdTreeDataAll[1].tags;
                    this.zczdTreeDataLevel2 = this.zczdTreeData[0].children;
                    this.zczdTreeDataLevel3 = this.zczdTreeDataLevel2[0].children;
                }
            }
        },

        getDataRule(){
            for(let i=0;i<this.ruleListArr.length;i++){
                let id = this.ruleListArr[i].rootCategoryId
                this.getRuleListFN(i,id)
            }
        },
        //规则子级数据获取 orderField":"sort","orderType":"desc","rootCategoryId":"19360","categoryType":"zhzsk_zsg_tag_type","level":1
        getRuleListFN(index,id){
            let data = {
                // rootId: id,
                // typeIds: '',
                // level: 1,

                orderField:'sort',
                orderType:'desc',
                rootCategoryId:id,
                categoryType:'zhzsk_zsg_tag_type',
                level:1
            }
            jczdGetTagTree(data).then((res) => {
                //console.log(res);
                this.ruleListArr[index].data = res.data.data
            })
        },
        //规则子级点击
        ruleChildClick(item,item_c,index){

            let sendZsgObj = {}
            sendZsgObj.path = item.type
            sendZsgObj.pId = item.id
            sendZsgObj.thatId = item_c.id
            // sendZsgObj.from = 'gw'
            // sendZsgObj.searchType = 0
            // sendZsgObj.tagTreeId = item_c.id
            //跳转路由
            this.$router.push({
                path:'/rule',
                query:sendZsgObj
            })
        },
        //获取焦点诊断分类
        getTreeJDZD(){
            let data = {
                rootCategoryId: '32578',
                categoryType: 'zhzsk_wddy_type',
				level:4,
            }
            this.dataLoading = true
            jczdGetTagTree(data).then(res => {
                this.jdzdTreeData = res.data.data
                for(let a=0;a<this.jdzdTreeData.length;a++){
                    this.jdzdTreeData[a].isOpen = false
                }
                this.jdzdTreeData[0].isOpen = true
                this.dataLoading = false
            })
        },
        //获取行业诊断
        getTreeHYZD(){
            let data = {
                rootCategoryId: '32576',
                categoryType: 'zhzsk_wddy_type',
				level:4,
            }
            this.dataLoading = true
            jczdGetTagTree(data).then(res => {
                this.hyzdTreeData = res.data.data
                this.hyzdTreeDataLevel2 = this.hyzdTreeData[0].childs
                this.dataLoading = false
            })
        },
        //获取政策诊断
        getTreeZczd(){
            this.dataLoading = true
            zczdGetTagTree({}).then(res => {
                this.zczdTreeDataAll = res.data.data
                this.zczdTreeData = res.data.data[1].tags;
                this.zczdTreeDataLevel2 = this.zczdTreeData[0].children;
                this.zczdTreeDataLevel3 = this.zczdTreeDataLevel2[0].children;
                this.dataLoading = false;
            })
        },
        //焦点诊断分类点击事件
        jdzdListCLick(item){
            this.jdzdCheckObj.id = item.id;
            this.jdzdCheckObj.name = item.name;
        },
        //收起展开操作
        sqzkClick(item,index){
            //判断点击的是否是当前的
            if(item.isOpen == true){
                item.isOpen = false
            }else{
                for(let a=0;a<this.jdzdTreeData.length;a++){
                    this.jdzdTreeData[a].isOpen = false
                }
                this.jdzdTreeData[index].isOpen = true
            }
            this.$forceUpdate()
        },
        //问题诊断的 重置
        userTextClear(){
            this.wentiUserText = '';
        },
        //
        userTextSubmit(){
            
            this.$message('提交诊断');
            //展示sse
            this.sendSEEObjWTZD.quesition = this.wentiUserText;
            this.sendSEEObjWTZD.sseCode = 'wtzd';
            this.sendSEEObjWTZD.sseTypeName = '';
            this.sendSEEObjWTZD.collectionType = 'aiw-wtzd';

            this.isShowWTZDSSE = false;
            setTimeout(() => {
                this.isShowWTZDSSE = true;
                this.wentiUserText = '';
            },50)
        },
        //
        textWillFn(){
            let timer = null
            let num = this.jqrText.length;
            let condition = 0;
            timer = setInterval(() => {
                let tText = this.jqrText.substring(condition,condition+1)
                this.jqrTextWill += tText;
                condition++
                //是否终止
                if(condition>=num){
                    clearInterval(timer)
                    timer = null;
                }
            }, 12);
            // let num = this.jqrText.length;
            // let condition = 0
            // do {
            //     condition++
            // } while (condition<num);
        },
        //开始稽查诊断按钮
        jczdStartBtn(text,sseCode){
            //判断所选分类
            if(this.jczdTypeIndex == 0){
                //判断是否为空 
                if(this.jdzdCheckObj.id == ''){
                    this.$message('请先选择你感兴趣的标签')
                    return
                }
                //焦点诊断的后续操作

                //问题
                this.sendSEEObj.quesition = this.jdzdCheckObj.name;
            }
            if(this.jczdTypeIndex == 1){
                //判断是否为空 
                if(this.hyzdCheckObj.id1 == ''&&this.hyzdCheckObj.id2 == ''){
                    this.$message('请先选择你感兴趣的标签')
                    return
                }
                //行业诊断的后续操作
                //问题
                if(this.hyzdCheckObj.name2!=''){
                    if(this.hyzdCheckObj.name1!=''){
                        this.sendSEEObj.quesition = this.hyzdCheckObj.name1 + '-' + this.hyzdCheckObj.name2;
                    }else{
                        this.sendSEEObj.quesition = this.hyzdCheckObj.name2;
                    }
                }else{
                    this.sendSEEObj.quesition = this.hyzdCheckObj.name1 ;
                }
            }

            if(this.jczdTypeIndex == 3){
                //判断是否为空 
                if(this.zczdCheckObj.id1 == ''&&this.zczdCheckObj.id2 == ''&&this.zczdCheckObj.id3 == ''){
                    this.$message('请先选择你感兴趣的标签')
                    return
                }
                //政策诊断的后续操作
                //问题
                if(this.zczdCheckObj.name1!=''){
                    this.sendSEEObj.quesition = this.zczdCheckObj.name1
                }
                if(this.zczdCheckObj.name2!=''){
                    if(this.zczdCheckObj.name1!=''){
                        this.sendSEEObj.quesition = this.sendSEEObj.quesition + '-' + this.zczdCheckObj.name2
                    }else{
                        this.sendSEEObj.quesition = this.zczdCheckObj.name2
                    }
                }
                if(this.zczdCheckObj.name3!=''){
                    if(this.zczdCheckObj.name1!=''||this.zczdCheckObj.name2!=''){
                        this.sendSEEObj.quesition = this.sendSEEObj.quesition + '-' + this.zczdCheckObj.name3
                    }else{
                        this.sendSEEObj.quesition = this.zczdCheckObj.name3
                    }
                }
            }
            
            //所属类型
            this.sendSEEObj.sseCode = sseCode=='zczd'?'zd':sseCode;
            this.sendSEEObj.sseTypeName = text;
            this.sendSEEObj.collectionType = this.collectionCodeObj[sseCode];
            this.isShowSSE = true;
        },

        //关闭 稽查诊断的 sse
        jczdCloseSSE(){
            this.isShowSSE = false;
        },
        //行业的两级选择
        hyzdLevel1CLick(item){
            //判断是否点的是同一个
            if(this.hyzdCheckObj.id1 != item.id){
                this.hyzdCheckObj.id1 = item.id;
                this.hyzdCheckObj.name1 = item.name;

                this.hyzdTreeDataLevel2 = item.childs;
                this.hyzdCheckObj.id2 = ''
                this.hyzdCheckObj.name2 = ''
            }
            
        },
        hyzdLevel2CLick(item){
            this.hyzdCheckObj.id2 = item.id
            this.hyzdCheckObj.name2 = item.name
        },
        //政策诊断的 几层级的选择
        zczdLevel1CLick(item,level){
            // 判断 层级
            if(level == 1){
                this.zczdTreeDataLevel2 = item.children;
                //判断点的是否是同一个
                if(this.zczdCheckObj.id1 != item.id){
                    this.zczdCheckObj.id2 = '';
                    this.zczdCheckObj.id3 = '';
                    this.zczdCheckObj.name2 = '';
                    this.zczdCheckObj.name3 = '';
                }
            }else if(level == 2){
                this.zczdTreeDataLevel3 = item.children;
                //判断点的是否是同一个
                if(this.zczdCheckObj.id2 != item.id){
                    this.zczdCheckObj.id3 = '';
                    this.zczdCheckObj.name3 = '';
                }
            }
            let ids = 'id' + level
            let names = 'name' + level
            this.zczdCheckObj[ids] = item.id
            this.zczdCheckObj[names] = item.name
        },
        //行业诊断 清除第 n 个
        hyzdClearCheck(index){
            //判断是否有下级
            let juniorKey = 'id' + (index + 1)
            if(this.hyzdCheckObj[juniorKey]&&this.hyzdCheckObj[juniorKey]!=''){
                //console.log(this.hyzdCheckObj[juniorKey])   
                this.$message({
                    message:'有子级被选中,请按级清除~',
                    type:'warning',
                }) 
                return        
            }

            //执行清除操作
            let ids = 'id' + index
            let names = 'name' + index
            this.hyzdCheckObj[ids] = ''
            this.hyzdCheckObj[names] = ''
        },
        //政策诊断的类型切换
        zczdTopTypeClick(item,index){
            //清空选中
            this.zczdCheckObj = {
                id1:'',
                id2:'',
                id3:'',
                name1:'',
                name2:'',
                name3:'',
            }
            //分类赋值
            this.zczdTopTypeIndex = index
            this.zczdTreeData = this.zczdTreeDataAll[index].tags;
            this.zczdTreeDataLevel2 = this.zczdTreeData[0].children
            this.zczdTreeDataLevel3 = this.zczdTreeDataLevel2[0].children
        },
        //政策诊断 清除第 n 个
        zczdClearCheck(index){
            //判断是否有下级
            let juniorKey = 'id' + (index + 1)
            if(this.zczdCheckObj[juniorKey]&&this.zczdCheckObj[juniorKey]!=''){
                //console.log(this.hyzdCheckObj[juniorKey])   
                this.$message({
                    message:'有子级被选中,请按级清除~',
                    type:'warning',
                }) 
                return        
            }
            //执行清除操作
            let ids = 'id' + index
            let names = 'name' + index
            this.zczdCheckObj[ids] = ''
            this.zczdCheckObj[names] = ''
        }
    },
    
}
</script>
<style lang="scss" scoped>

/** 我的日常咨询 我的检测报告 start*/

.cjkTop {
    width: 100%;
    min-height: 100px;
    /*overflow: hidden;*/
    margin-top:15px;
    /*box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);*/
    margin-bottom:20px;
}

/** 我的日常咨询 我的检测报告 end*/


/** 我的稽查诊断 start*/
.myJCZD{
    width:100%;
    overflow: hidden;
    margin-bottom:15px;
    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
    .jczdTopNav{
        width: 850px;
        height: 100px;
        line-height: 100px;
        background: #0F59A4;
        font-weight: 700;
        font-size: 28px;
        color: #FFFFFF;
        text-align: center;
        .jczdIcon{
            width: 40px;
            height: 45px;
            position: relative;
            top:14px;
            margin-right:20px;
        }
    }
    .jczdContent{
        width:100%;
        box-sizing: border-box;
        padding:20px;
        overflow: hidden;
        background: #ffffff;
        .jczdListBox{
            width:100%;
            height:45px;
            .jczdNavListCheck{
                font-weight: 700;
                font-size: 20px;
                color: #FFFFFF!important;
                background: linear-gradient( 270deg, #0F59A4 0%, #0F59A4 100%)!important;
            }
            .jczdNavList{
                width: 148px;
                height: 45px;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                float:left;
                margin-right:18px;
                font-weight: 400;
                font-size: 20px;
                color: #0F59A4;
                text-align: center;
                line-height: 45px;
                cursor:pointer;
            }
        }
        .jczdListBorder{
            width: 810px;
            height: 3px;
            background: #0F59A4;
        }
        .jczdBottom{
            width:100%;
            overflow: hidden;
            -webkit-user-select: none;
            /***焦点诊断 start ******/
            .jdzdBox{
                width:100%;
                overflow: hidden;
                .startCheckView{
                    width:100%;
                    height:50px;
                    margin-top:15px;
                    .startCheckLeft{
                        width:645px;
                        height: 50px;
                        line-height: 50px;
                        background: #F8F8F8;
                        float:left;
                        box-sizing: border-box;
                        padding-left:18px;
                    }
                    .startBtn{
                        width: 150px;
                        height: 50px;
                        line-height: 50px;
                        background: #0F59A4;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        float:left;
                        font-size: 18px;
                        color: #FFFFFF;
                        text-align: center;
                        cursor:pointer;
                        -webkit-user-select: none;
                        margin-left:15px;
                    }
                }
                .jczdTreeListBox{
                    width:100%;
                    overflow: hidden;
                    margin-top:5px;
                    .jczdTreeLevelOne{
                        width:100%;
                        overflow: hidden;
                        .jczdTreeListLevelOneName{
                            width: 810px;
                            height: 40px;
                            line-height: 40px;
                            background: #EEF8FF;
                            font-weight: 700;
                            font-size: 18px;
                            color: #0F59A4;
                            box-sizing: border-box;
                            padding-left:20px;
                            margin-top:10px;
                            position: relative;
                            .listLevelOneRightIsOpen{
                                width: 50px;
                                height: 20px;
                                line-height: 20px;
                                background: #0F59A4;
                                border-radius: 2px 2px 2px 2px;
                                position: absolute;
                                top:10px;
                                right:20px;
                                font-weight: 400;
                                font-size: 12px;
                                color: #FFFFFF;
                                cursor:pointer;
                                text-align: center;
                                img{
                                    width: 12px;
                                    height: 12px;
                                    margin-right:4px;
                                    position: relative;
                                    top:2px;
                                }
                            }
                        }
                        .jczdTreeLevelTwo{
                            width:100%;
                            overflow: hidden;
                            display: flex;
                            flex-wrap: wrap;
                            padding-bottom:10px;
                            /*justify-content: space-between;*/
                            .jczdTreeChildList:nth-child(5n +1){
                                margin-left:0;
                            }
                            .jczdTreeChildList{
                                width: 148px;
                                min-height: 50px;
                                text-align: center;
                                background: #F8F8F8;
                                margin-top:10px;
                                margin-left:17px;
                                cursor:pointer;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding:0 10px;
                                box-sizing: border-box;
                                position: relative;
                                .treeListCheck{
                                    width:20px;
                                    height:20px;
                                    position: absolute;
                                    bottom:0;
                                    right:0;
                                    img{
                                        width:100%;
                                        height:100%;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            /***焦点诊断 end ******/


            /***行业诊断 start ******/
            .hyzdBox{
                width:100%;
                overflow: hidden;
                .startCheckView{
                    width:100%;
                    overflow: hidden;
                    margin-top:15px;
                    .startCheckLeft{
                        width:645px;
                        min-height: 50px;
                        background: #F8F8F8;
                        float:left;
                        box-sizing: border-box;
                        padding-left:18px;
                        .startCheckLeftTop{
                            width:100%;
                            height:20px;
                            margin-top:15px;
                            margin-bottom:15px;
                        }
                        .hyzdCheck{
                            width:100%;
                            height:30px;
                            line-height: 30px;
                            margin-bottom:10px;
                            .hyzdCheckLeft{
                                display: inline-block;
                            }
                            .hyzdCheckRight{
                                display: inline-block;
                                padding:0 10px;
                                background: #EEF8FF;
                                border-radius: 15px 15px 15px 15px;
                                font-weight: 400;
                                font-size: 16px;
                                color: #0F59A4;
                                .closeX{
                                    width: 20px;
                                    height: 20px;
                                    line-height: 20px;
                                    text-align: center;
                                    display: inline-block;
                                    border-radius:50% ;
                                    background: #0F59A4;
                                    color:#ffffff;
                                    cursor:pointer;
                                    margin-left:6px;
                                }
                            }
                        }
                    }
                    .startBtn{
                        width: 150px;
                        height: 50px;
                        line-height: 50px;
                        background: #0F59A4;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        float:left;
                        font-size: 18px;
                        color: #FFFFFF;
                        text-align: center;
                        cursor:pointer;
                        -webkit-user-select: none;
                        margin-left:15px;
                    }
                }
                .hyzdTreeListBox{
                    width:100%;
                    overflow: hidden;
                    .hyzdTreeLevel{
                        width:100%;
                        overflow: hidden;
                        .hyzdTreeLevelTop{
                            width: 810px;
                            height: 40px;
                            line-height: 40px;
                            background: #EEF8FF;
                            box-sizing: border-box;
                            padding-left:20px;
                            font-weight: 700;
                            font-size: 18px;
                            color: #0F59A4;
                            margin-top:15px;
                        }
                        .hyzdTreeChild{
                            width:100%;
                            overflow: hidden;
                            display: flex;
                            flex-wrap: wrap;
                            .hyzdTreeChildList:nth-child(5n +1){
                                margin-left:0;
                            }
                            .hyzdTreeChildList{
                                width: 148px;
                                min-height: 50px;
                                text-align: center;
                                background: #F8F8F8;
                                margin-top: 10px;
                                margin-left: 17px;
                                cursor: pointer;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding: 0 10px;
                                box-sizing: border-box;
                                position: relative;
                                .treeListCheck{
                                    width:20px;
                                    height:20px;
                                    position: absolute;
                                    bottom:0;
                                    right:0;
                                    img{
                                        width:100%;
                                        height:100%;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            /***行业诊断 end ******/

            /***问题诊断 start */
            .wtzdBox{
                width:100%;
                min-height:520px;
                background: #FFFFFF;
                //box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                .jiqirenView{
                    width:100%;
                    min-height:360px;
                    overflow: hidden;
                    padding-bottom: 20px;
                    .jqrTop{
                        width:100%;
                        min-height:120px;
                        box-sizing: border-box;
                        padding-top:20px;
                        .jqrLeft{
                            width:58px;
                            height:58px;
                            border-radius:50%;
                            float:left;
                            //background: rgb(184,210,253);
                            img{
                                width:100%;
                                height:100%;
                            }
                        }
                        .jqrText{
                            width: 520px;
                            overflow: hidden;
                            float:left;
                            background: #EEF8FF;
                            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                            border-radius: 2px 8px 8px 8px;
                            box-sizing: border-box;
                            padding:12px 20px;
                            margin-top:20px;
                            margin-left:12px;
                            font-weight: 400;
                            font-size: 16px;
                            line-height: 24px;
                            color: #3D3D3D;
                        }
                    }
                }
                .userTextView{
                    width:100%;
                    height:180px;
                    box-sizing: border-box;
                    border-top:1px solid #D8D8D8;
                    .userTextTop{
                        width:100%;
                        height:120px;
                        box-sizing: border-box;
                        padding: 14px 0;
                        overflow: hidden;
                    }
                    ::v-deep .el-textarea >.el-textarea__inner{
                        border: 0px solid #DCDFE6!important;
                    }
                    .userTextBottom{
                        width:100%;
                        height:45px;
                        .userTextNum{
                            width:590px;
                            height:45px;
                            float:left;
                            p{
                                width:100%;
                                height: 24px;
                                font-family: Source Han Sans, Source Han Sans;
                                font-weight: 400;
                                font-size: 16px;
                                color: #8C8C8C;
                                line-height: 24px;
                                margin-top:20px;
                            }
                        }
                        .userTextBtn{
                            width:calc(100% - 590px);
                            height:45px;
                            float:left;
                            .userTextBtnClear{
                                width: 100px;
                                height: 45px;
                                line-height: 45px;
                                text-align: center;
                                background: #EEF8FF;
                                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                                float:left;
                                margin-left:10px;
                                font-size: 20px;
                                color: #8C8C8C;
                                cursor:pointer;
                            }
                            .userTextBtnSubmit{
                                width: 100px;
                                height: 45px;
                                line-height: 45px;
                                text-align: center;
                                background: linear-gradient( 270deg, #0F59A4 0%, #0F59A4 100%);
                                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                                float:left;
                                margin-left:10px;
                                font-size: 20px;
                                color: #FFFFFF;
                                cursor:pointer;
                            }
                        }
                    }
                }
            }
            /***问题诊断 end ******/

            /***政策诊断 start ******/
            .zczdBox{
                width:100%;
                overflow: hidden;
                .zczdTopNav{
                    width:100%;
                    height:40px;
                    margin-top:15px;
                    .zczdTopNavListCheck{
                        background: #0F59A4!important;
                        color: #FFFFFF!important;
                    }
                    #specialView{
                        position: absolute;
                        top:-1000px;
                    }
                    .zczdTopNavList{
                        width: 148px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        background: #EEF8FF;
                        border-radius: 20px 20px 20px 20px;
                        font-weight: 400;
                        font-size: 16px;
                        color: #0F59A4;
                        float:left;
                        margin-right:18px;
                        cursor:pointer;
                    }
                }
                .startCheckView{
                    width:100%;
                    overflow: hidden; 
                    margin-top:15px;
                    .startCheckLeft{
                        width:645px;
                        overflow: hidden;
                        background: #F8F8F8;
                        float:left;
                        box-sizing: border-box;
                        /*padding-left:18px;*/
                        .weixuanzhong{
                            padding:16px 18px;
                            line-height: 24px;
                        }
                        .moreCheckView{
                            width:645px;
                            overflow: hidden;
                            padding-left:18px;
                        }
                        .startCheckLeftTop{
                            width:100%;
                            height:20px;
                            margin-top:15px;
                            margin-bottom:15px;
                        }
                        .zczdCheck{
                            width:100%;
                            height:30px;
                            line-height: 30px;
                            margin-bottom:10px;
                            .zczdCheckLeft{
                                display: inline-block;
                            }
                            .zczdCheckRight{
                                display: inline-block;
                                padding:0 10px;
                                background: #EEF8FF;
                                border-radius: 15px 15px 15px 15px;
                                font-weight: 400;
                                font-size: 16px;
                                color: #0F59A4;
                                .closeX{
                                    width: 20px;
                                    height: 20px;
                                    line-height: 20px;
                                    text-align: center;
                                    display: inline-block;
                                    border-radius:50% ;
                                    background: #0F59A4;
                                    color:#ffffff;
                                    cursor:pointer;
                                    margin-left:6px;
                                }
                            }
                        }
                    }
                    .startBtn{
                        width: 150px;
                        height: 50px;
                        line-height: 50px;
                        background: #0F59A4;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        float:left;
                        font-size: 18px;
                        color: #FFFFFF;
                        text-align: center;
                        cursor:pointer;
                        -webkit-user-select: none;
                        margin-left:15px;
                    }
                }
                .zczdTreeListBox{
                    width:100%;
                    overflow: hidden;
                    .zczdTreeLevel{
                        width:100%;
                        overflow: hidden;
                        .zczdTreeLevelTop{
                            width: 810px;
                            height: 40px;
                            line-height: 40px;
                            background: #EEF8FF;
                            box-sizing: border-box;
                            padding-left:20px;
                            font-weight: 700;
                            font-size: 18px;
                            color: #0F59A4;
                            margin-top:15px;
                        }
                        .zczdTreeChild{
                            width:100%;
                            overflow: hidden;
                            display: flex;
                            flex-wrap: wrap;
                            .zczdTreeChildList:nth-child(5n +1){
                                margin-left:0;
                            }
                            .zczdTreeChildList{
                                width: 148px;
                                min-height: 50px;
                                text-align: center;
                                background: #F8F8F8;
                                margin-top: 10px;
                                margin-left: 17px;
                                cursor: pointer;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding: 0 10px;
                                box-sizing: border-box;
                                position: relative;
                                .treeListCheck{
                                    width:20px;
                                    height:20px;
                                    position: absolute;
                                    bottom:0;
                                    right:0;
                                    img{
                                        width:100%;
                                        height:100%;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            /***政策诊断 end ******/
        }
    }
    .colorSpanBlue{
        color:#0F59A4!important;
    }
}

/** 我的稽查诊断 end*/


/** 场景规则定制库 start*/
.ruleView{
    width:100%;
    overflow:hidden;
    .ruleList{
        width:100%;
        overflow:hidden;
        background: #FFFFFF;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
        margin-bottom:15px;
        .ruleListTitle{
            width: 850px;
            height: 65px;
            line-height: 65px;
            background: #0F59A4;
            box-sizing: border-box;
            padding-left:19px;
            font-weight: 700;
            font-size: 22px;
            color: #FFFFFF;
        }
        .ruleListChild{
            width:100%;
            overflow:hidden;
            box-sizing: border-box;
            padding:10px 0 20px 0px;
            .ruleChildList{
                width: 148px;
                height: 50px;
                text-align: center;
                font-weight: 400;
                font-size: 16px;
                color: #3D3D3D;
                background: #F8F8F8;
                float:left;
                margin-top:10px;
                margin-left:18px;
                cursor:pointer;
                -webkit-user-select: none;
                display: flex;
                justify-content: center;
                align-items: center;
                padding:0 10px;
                box-sizing: border-box;
            }
        }
    }
}

/** 场景规则定制库 end*/


</style>
